import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { lazyUpdateFavoritePosition } from 'owa-favorites';
import folderStore from 'owa-folders';
import publicFolderFavoriteStore from 'owa-public-folder-favorite/lib/store/publicFolderFavoriteStore';
import { showFavoritesContextMenu } from 'owa-mail-favorites-store/lib/actions/favoritesContextMenu';
import { getCustomIcon } from 'owa-mail-folder-forest-actions';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import { FolderNode } from 'owa-mail-folder-view';
import { DRAG_X_OFFSET, DRAG_Y_OFFSET } from 'owa-mail-folder-view';
import { listViewStore } from 'owa-mail-list-store';
import * as lazyTriageActions from 'owa-mail-triage-action';
import { getAnchorForContextMenu } from 'owa-positioning';
import * as React from 'react';
var styles = require('./FavoriteNode.scss');
var FavoriteFolderNode = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteFolderNode, _super);
    function FavoriteFolderNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDraggableFavoriteFolderNode = function (textClassNames) {
            var folder = _this.getFolder();
            return React.createElement("span", { className: textClassNames }, folder.DisplayName);
        };
        _this.getFolder = function () {
            if (_this.props.isPublicFolder) {
                return publicFolderFavoriteStore.folderTable.get(_this.props.folderId);
            }
            return folderStore.folderTable.get(_this.props.folderId);
        };
        _this.onContextMenu = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            showFavoritesContextMenu(_this.props.favoriteId, _this.props.isPublicFolder
                ? 6 /* PublicFolder */
                : 0 /* Folder */, _this.getFolder(), getAnchorForContextMenu(evt));
        };
        _this.onDrop = function (dragData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var itemType, _a, mailListItemPartDragData, tableView, moveItemsBasedOnNodeIds, mailListRowDragData, tableViewId, rowKeys, draggedFavorite, dropTargetId, dragTargetId, updateFavoritePosition;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        itemType = dragData.itemType;
                        _a = itemType;
                        switch (_a) {
                            case DraggableItemTypes.MailListItemPart: return [3 /*break*/, 1];
                            case DraggableItemTypes.MailListRow: return [3 /*break*/, 3];
                            case DraggableItemTypes.MultiMailListConversationRows: return [3 /*break*/, 3];
                            case DraggableItemTypes.MultiMailListMessageRows: return [3 /*break*/, 3];
                            case DraggableItemTypes.FavoriteNode: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 1:
                        mailListItemPartDragData = dragData;
                        tableView = listViewStore.tableViews.get(mailListItemPartDragData.tableViewId);
                        return [4 /*yield*/, lazyTriageActions.lazyMoveItemsBasedOnNodeIds.import()];
                    case 2:
                        moveItemsBasedOnNodeIds = _b.sent();
                        moveItemsBasedOnNodeIds(mailListItemPartDragData.nodeIds, this.props.folderId, tableView.id, 'Drag');
                        return [3 /*break*/, 6];
                    case 3:
                        {
                            mailListRowDragData = dragData;
                            tableViewId = mailListRowDragData.tableViewId;
                            rowKeys = mailListRowDragData.rowKeys;
                            lazyTriageActions.lazyMoveMailListRows.importAndExecute(rowKeys, this.props.folderId, tableViewId, 'Drag');
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        draggedFavorite = dragData;
                        dropTargetId = this.props.favoriteId;
                        dragTargetId = draggedFavorite.favoriteId;
                        return [4 /*yield*/, lazyUpdateFavoritePosition.import()];
                    case 5:
                        updateFavoritePosition = _b.sent();
                        updateFavoritePosition(dragTargetId /* idToUpdate */, dropTargetId /* desitnationFolderId */, draggedFavorite.favoriteType);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.canDrop = function (dragData) {
            var itemType = dragData.itemType;
            switch (itemType) {
                case DraggableItemTypes.MailListItemPart:
                case DraggableItemTypes.MailListRow:
                case DraggableItemTypes.MultiMailListConversationRows:
                case DraggableItemTypes.MultiMailListMessageRows:
                case DraggableItemTypes.FavoriteNode:
                    return true;
                case DraggableItemTypes.MailFolderNode:
                default:
                    return false;
            }
        };
        _this.onDragOver = function (dragData) {
            _this.isDragOver = true;
        };
        _this.onDragLeave = function () {
            _this.isDragOver = false;
        };
        _this.getDragData = function () {
            var displayName = _this.getFolder().DisplayName;
            var folderNodeDragData = {
                itemType: DraggableItemTypes.FavoriteNode,
                favoriteId: _this.props.favoriteId,
                favoriteType: _this.props.isPublicFolder
                    ? 6 /* PublicFolder */
                    : 0 /* Folder */,
                displayName: displayName,
            };
            return folderNodeDragData;
        };
        _this.getDragPreview = function (folderNodeDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragPreview;
            elem.innerText = folderNodeDragData.displayName;
            return elem;
        };
        return _this;
    }
    FavoriteFolderNode.prototype.render = function () {
        var folder = this.getFolder();
        var folderViewState = getFolderViewStateFromId(this.props.favoriteId);
        var itemType = folderViewState.drop.draggableItemType;
        return (React.createElement(DragAndDroppable, { dragViewState: folderViewState.drag, getDragData: this.getDragData, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, dropViewState: folderViewState.drop, onDrop: this.onDrop, canDrop: this.canDrop, onDragOver: this.onDragOver, onDragLeave: this.onDragLeave },
            React.createElement(FolderNode, { customIcon: getCustomIcon(this.props.folderId, true), displayName: folder.DisplayName, folderId: this.props.folderId, isDroppedOver: folderViewState.drop.isDragOver && this.isDragOver, isBeingDragged: folderViewState.drag.isBeingDragged, key: this.props.folderId, onContextMenu: this.onContextMenu, renderCustomTreeNodeDisplay: this.renderDraggableFavoriteFolderNode, showHoverStateOnDroppedOver: itemType == DraggableItemTypes.MailListRow ||
                    itemType == DraggableItemTypes.MultiMailListConversationRows ||
                    itemType == DraggableItemTypes.MultiMailListMessageRows ||
                    itemType == DraggableItemTypes.MailListItemPart, treeType: 'favorites', isPublicFolder: this.props.isPublicFolder })));
    };
    FavoriteFolderNode = tslib_1.__decorate([
        observer
    ], FavoriteFolderNode);
    return FavoriteFolderNode;
}(React.Component));
export default FavoriteFolderNode;
//# sourceMappingURL=FavoriteFolderNode.js.map